//Kersvers Custom Code

document.addEventListener("DOMContentLoaded", function () {
  // Change header logo on scroll
  const header = document.querySelector(".header");
  const logoImage = document.querySelector(".header__logo-image");

  const defaultLogo =
    "https://cdn.shopify.com/s/files/1/0860/4952/1988/files/Firefighterbag-logo-white.svg?v=1725444120";
  
  const scrolledLogo =
    "https://cdn.shopify.com/s/files/1/0860/4952/1988/files/Firefighterbag-logo-black.svg?v=1725444120";

  const defaultSrcSet = 
    "https://cdn.shopify.com/s/files/1/0860/4952/1988/files/Firefighterbag-logo-white.svg?v=1725444120 280w, https://cdn.shopify.com/s/files/1/0860/4952/1988/files/Firefighterbag-logo-white.svg?v=1725444120 420w";
  
  const scrolledSrcSet = 
    "https://cdn.shopify.com/s/files/1/0860/4952/1988/files/Firefighterbag-logo-black.svg?v=1725444120 280w, https://cdn.shopify.com/s/files/1/0860/4952/1988/files/Firefighterbag-logo-black.svg?v=1725444120 420w";

  const changeLogoOnScroll = () => {
    if (window.scrollY === 0) {
      logoImage.src = defaultLogo;
      logoImage.srcset = defaultSrcSet;
      return; 
    }

    if (header.classList.contains("is-solid")) {
      logoImage.src = scrolledLogo;
      logoImage.srcset = scrolledSrcSet;
    } else {
      logoImage.src = defaultLogo;
      logoImage.srcset = defaultSrcSet;
    }
  };

  const changeLogoOnHover = () => {
    logoImage.src = scrolledLogo;
    logoImage.srcset = scrolledSrcSet;
  };

  const revertLogoOnHoverOut = () => {
    if (window.scrollY === 0) {
      logoImage.src = defaultLogo;
      logoImage.srcset = defaultSrcSet;
    } else {
      logoImage.src = scrolledLogo;
      logoImage.srcset = scrolledSrcSet;
    }
  };

  window.addEventListener("scroll", changeLogoOnScroll);
  header.addEventListener("mouseover", changeLogoOnHover);
  header.addEventListener("mouseout", revertLogoOnHoverOut);

  changeLogoOnScroll();
});